/*
  Cards section slider new
*/

export function cardSectionGridSlider() {
  $('.cards-section.grid .cards-wrp').flickity({
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
  });
}